import { render } from "./AllTransactionComponent.vue?vue&type=template&id=1c52a10c"
import script from "./AllTransactionComponent.vue?vue&type=script&lang=js"
export * from "./AllTransactionComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__